.board {
  position: absolute;
  border: 2px solid var(--color-accent-200);
  cursor: grab;
  box-shadow:
    0 0 0 1px rgb(0 0 0 / 0.45),
    0 0 18px rgb(145 132 217 / 0.32);

  /* LOAD-BEARING. The element is border-box with a 2px border, so without these the
     gradient repeats over the padding box — 4px smaller — and 9 cells become 8.86. */
  background-origin: border-box;
  background-clip: border-box;
}

.board:active {
  cursor: grabbing;
}

/* — rulers — */

.columnRuler,
.rowRuler {
  position: absolute;
  display: grid;
  pointer-events: none;
  font-weight: 500;
  line-height: 1;
  text-shadow: 0 1px 3px rgb(0 0 0 / 0.95);
}

/* Both rulers are positioned from the shared layout (ADR-0012) rather than pinned to the
   board's edges, so the editor shows the labels where the export will draw them —
   including flipping inside the board when there is no room outside it. */

/* Offsets come from the shared ruler layout — see GridOverlay.tsx. Both bands are inset by
   the negative border width so they span the board's border box, which is the box the cells
   are measured against. */

.columnRuler {
  text-align: center;
}

.rowRuler {
  /* horizontal placement comes from the shared ruler layout */
}

.rowRuler > div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.rowRuler[data-flipped='true'] > div {
  justify-content: flex-start;
}

/* — corner handles — */

.handle {
  position: absolute;
  width: 22px;
  height: 22px;
}

.nw {
  left: -11px;
  top: -11px;
  border-left: 2px solid var(--color-accent);
  border-top: 2px solid var(--color-accent);
  cursor: nwse-resize;
}

.ne {
  right: -11px;
  top: -11px;
  border-right: 2px solid var(--color-accent);
  border-top: 2px solid var(--color-accent);
  cursor: nesw-resize;
}

.sw {
  left: -11px;
  bottom: -11px;
  border-left: 2px solid var(--color-accent);
  border-bottom: 2px solid var(--color-accent);
  cursor: nesw-resize;
}

.se {
  right: -11px;
  bottom: -11px;
  border-right: 2px solid var(--color-accent);
  border-bottom: 2px solid var(--color-accent);
  cursor: nwse-resize;
}

/* Desktop: larger handles, as the handoff specifies. */
@media (min-width: 900px) {
  .handle {
    width: 26px;
    height: 26px;
  }

  .nw,
  .sw {
    left: -13px;
  }

  .ne,
  .se {
    right: -13px;
  }

  .nw,
  .ne {
    top: -13px;
  }

  .sw,
  .se {
    bottom: -13px;
  }
}
